import BaseFormatter from './base'
import { getTagVerdict, getVerdictMarks, has } from '../../helpers'
import { SignalVerdict, VerdictData } from '../../types'
import { SimilarityResult } from '../../types/similarity-result'

/**
 * Format general report verdict
 */
export default class VerdictFormatter extends BaseFormatter {
  /**
   * Format original report data
   *
   * @param data
   * @param report
   */
  format(data: { [key: string]: any }, report: { [key: string]: any }): void {
    if (has(data, 'similaritySearchResults')) {
      report.similaritySearchResults = data.similaritySearchResults.map((result: SimilarityResult) => ({
        ...result,
        details: { ...result.details, tags: this.sortTagNames(result.details?.tags) },
      }))
    }

    if (!has(data, 'finalVerdict')) {
      return
    }

    let verdictName = data.finalVerdict.verdict.toLowerCase() as SignalVerdict
    if (verdictName === SignalVerdict.Unknown && data.finalVerdict.verdictLabel === SignalVerdict.System_error) {
      verdictName = SignalVerdict.System_error
    }

    const fileResource = this.getResource(data, 'file')
    const verdict: VerdictData = {
      name: verdictName,
      confidence: data.finalVerdict.confidence,
      threatLevel: data.finalVerdict.threatLevel,
      interestingScore: data.interestingScore,
    }

    if (data.verdictHistory && data.verdictHistory.length) {
      verdict.original = data.verdictHistory[0].verdict
      report.verdictHistory = data.verdictHistory
    }
    if (fileResource?.verdict?.comment) {
      verdict.comment = fileResource.verdict.comment
    }

    report.verdict = verdict
  }

  /**
   * Similarity tags are plain names with no verdict, so they are sorted by the verdict their name gives
   */
  sortTagNames(tags?: string[]): string[] | undefined {
    const weight = (name: string) => getVerdictMarks(getTagVerdict({ source: '', tag: { name } }))

    return tags && [...tags].sort((a, b) => weight(a) - weight(b))
  }
}
